import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/cn';
import { ICONS } from '@/components/ui/icons';

export interface LoadingStateProps {
  className?: string;
  compact?: boolean;
}

export function LoadingState({ className, compact = false }: LoadingStateProps): ReactNode {
  const { t } = useTranslation();
  const Spinner = ICONS.spinner;
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex items-center justify-center gap-2 text-xs text-subtle',
        compact ? 'py-4' : 'py-16',
        className,
      )}
    >
      <Spinner aria-hidden className="size-4 animate-spin" />
      <span>{t('common.loading')}</span>
    </div>
  );
}
